<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="coutry-page-container">
          <div v-for="data in countryData" :key="data.CountryName" class="inner-container">
            <!-- NOSONAR -->
            <a :href="data.Url">
              <img :src="data.CountryFlagIcon" alt="" />
              <p>{{ data.CountryName }}</p>
            </a>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mixa-country-page',
  props: {
    countryData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    navigateTo(url) {
      window.location.href = url;
    },
  },
};
</script>
